import { render, staticRenderFns } from "./FaceDetection.vue?vue&type=template&id=064e2068&scoped=true&"
import script from "./FaceDetection.vue?vue&type=script&lang=js&"
export * from "./FaceDetection.vue?vue&type=script&lang=js&"
import style0 from "./FaceDetection.vue?vue&type=style&index=0&id=064e2068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e2068",
  null
  
)

export default component.exports